<div class="ask-our-docs-chat-container">
  <iframe #myIframe [src]="safeUrl"></iframe>
</div>
